import { LegolandNavbar, useMeQuery } from 'legoland-sdk/dist/experimental';
import { useRouteMatch } from 'react-router-dom';
import { AppNavbarMenu } from "./AppNavbarMenu";
import { jsx as _jsx } from "react/jsx-runtime";
const breakpoint = 1090;
export const AppNavbar = () => {
  const meQuery = useMeQuery();
  const loginPageMatch = useRouteMatch({
    exact: true,
    path: '/login'
  });
  const passwordPageMatch = useRouteMatch('/login/(activate|set-password|forgot-password)');
  const registrationPageMatch = useRouteMatch('/register');
  const shouldShowSignIn = Boolean(registrationPageMatch || passwordPageMatch);
  const shouldShowSignUp = Boolean(loginPageMatch);
  return /*#__PURE__*/_jsx(LegolandNavbar, {
    $zIndex: "100",
    authHintText: shouldShowSignIn ? 'Already have a MOVE account?' : shouldShowSignUp ? "Don't have a MOVE account yet?" : undefined,
    breakpoint: breakpoint,
    meMenuBreakpoint: 1320,
    productName: "Move",
    showSignIn: shouldShowSignIn,
    showSignUp: shouldShowSignUp,
    trackingCategory: "dashboard interaction",
    "data-sentry-element": "LegolandNavbar",
    "data-sentry-component": "AppNavbar",
    "data-sentry-source-file": "AppNavbar.tsx",
    children: meQuery.data?.me && /*#__PURE__*/_jsx(AppNavbarMenu, {
      breakpoint: breakpoint
    })
  });
};